module.exports = __webpack_public_path__ + "static/media/switch_off.d1d3946e.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/BooleanState/img/switch_off.png
// module id = 582
// module chunks = 0